// @ts-ignore no types
import { renderStyledTagText } from 'feedback-shared-ui/tokens';
import Selectors from '../constants/Selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RatingQuestion = ({
  children,
  question,
  contactProperties
}) => /*#__PURE__*/_jsxs("div", {
  className: "feedback-question",
  children: [/*#__PURE__*/_jsx("h5", {
    className: "question-text",
    "data-selenium-test": Selectors.SURVEY_QUESTION,
    children: /*#__PURE__*/_jsx("span", {
      "data-selenium-test": `token-preview-tag-SURVEY_QUESTION`,
      children: question && renderStyledTagText(question, contactProperties)
    })
  }), children]
});
export default RatingQuestion;